import gql from 'graphql-tag';
import { useQuery } from '@vue/apollo-composable';

const FIND_DUPLICATES = gql`
  query FindDuplicates($leadid: ID) {
    findDuplicates(leadid: $leadid) {
      companies {
        COMPANYID
        NAME
        address {
          LINE1
          LINE2
          CITY
          STATE
          POSTALCODE
        }
        phones {
          TYPEID
          NUMBERDISPLAY
          EXT
        }
      }
      contacts {
        CONTACTID
        FIRSTNAME
        LASTNAME
        company {
          NAME
        }
        address {
          LINE1
          LINE2
          CITY
          STATE
          POSTALCODE
        }
        phones {
          NUMBERDISPLAY
          TYPEID
          EXT
        }
        email {
          ADDRESS
        }
      }
    }
  }
`;

export default function useFindDuplicates(leadid) {
  const { result, error, refetch, loading } = useQuery(
    FIND_DUPLICATES,
    () => ({
      leadid,
    }),
    { fetchPolicy: 'no-cache' }
  );

  return {
    result,
    error,
    refetch,
    loading,
  };
}
